export const resetButtonStyles = props => `
  -webkit-appearance: none;
  background-color: transparent;
  outline: none;
  box-shadow: none;
  border-radius: 0;
  border: 0;
  padding: 0;
`
